<template>
    <div class="settings-notifications">
        <h2 class="h2 mt-5 mb-4">Powiadomienia e-mail i SMS</h2>

        <!-- E-mail notifications -->
        <section>
            <div class="row" v-if="userData && userDataStatus === 'idle'">
                <div class="col-12">
                    <div class="card min-h-0 p-4">
                        <recipients-email />
                    </div>
                </div>
            </div>
        </section>

        <!-- SMS notifications -->
        <section class="mt-5">
            <div class="row" v-if="userData && userDataStatus === 'idle'">
                <div class="col-lg-8 mb-4 mb-lg-0">
                    <div class="card min-h-0 p-4">
                        <recipients-sms />
                    </div>
                </div>
                <div class="col-lg-4 mb-4 mb-lg-0">
                    <ui-settings-card v-if="!isShopUser">
                        <billing-documents-management />
                    </ui-settings-card>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import UiSettingsCard from '@/components/settings/UiSettingsCard.vue'
import BillingDocumentsManagement from '@/components/settings/BillingDocumentsManagement.vue'
import RecipientsSms from '@/components/settings/notifications/RecipientsSms.vue'
import RecipientsEmail from '@/components/settings/notifications/RecipientsEmail.vue'

export default {
    components: {
        RecipientsSms,
        RecipientsEmail,
        UiSettingsCard,
        BillingDocumentsManagement
    },

    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },

        isShopUser() {
            return this.$store.getters.isShopUser
        },

        userData() {
            return this.$store.getters.getUser
        },

        userDataStatus() {
            return this.$store.getters.getUserStatus
        }
    },

    created() {
        this.$store.dispatch('recipientsFetch')
    }
}
</script>
